<template>
  <div>
    <Profile caption="Profile" :profile="objs.accounts" />
    <div v-if="objs.type == 0">
      <Cometencys
        :caption="obj.title"
        class="mb-3"
        v-for="(obj, index) in objs.item"
        :item="obj.item"
        :key="competencyKey(obj, index, 0)"
        :type="0"
      />
    </div>

    <div v-if="objs.type == 1" >
      <Cometencys
        :caption="obj.title"
        class="mb-3"
        v-for="(obj, index) in profileStructureItems"
        :key="competencyKey(obj, index, 1)"
        :item="obj.item"
        :type="1"
      />
    </div>


<!--    <CRow class="mb-4">-->
<!--      <CCol class="text-right">-->

<!--        <CButton class="ml-2" size="sm" color="danger" shape="pill" variant="outline" >-->
<!--          <span class="font-weight-bold pr-1"><CIcon name="cil-save" />  UnSend </span>-->
<!--        </CButton>-->
<!--        <CButton class="ml-2" size="sm" color="success" shape="pill" variant="outline">-->
<!--          <span class="font-weight-bold pr-1"><CIcon name="cil-save" />  Save </span>-->
<!--        </CButton>-->
<!--        <CButton class="ml-2" size="sm" color="info" shape="pill" variant="outline" >-->
<!--          <span class="font-weight-bold pr-1"><CIcon name="cil-hand-point-up" />  Send </span>-->
<!--        </CButton>-->
<!--      </CCol>-->
<!--    </CRow>-->

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import moment from "moment";
import Profile from "@/projects/views/E-Performances/Estimate/components/Profile";
import Cometencys from "@/projects/views/E-Performances/Estimate/components/Cometencys";

export default {
  name: 'CometencyParent',
  components: {Cometencys, Profile},
  props: {

    objs: {
      type: Object,
      default() {
        return null
      }
    },


  },

  data: function () {
    return {

    }
  },

  mounted() {

  },

  created() {
    this.onInit()

  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
    },

    onLoad() {
    },

    findAllParentsById(node, targetId, parents = []) {
      if (node.accounts._id === targetId) {
        return parents.map(parent => parent.accounts._id);
        // return parents;
      }
      if (node.children) {
        for (let child of node.children) {
          const result = this.findAllParentsById(child, targetId, [...parents, node]);
          if (result) {
            return result;
          }
        }
      }
      return null;
    },



    findObjectByIdInArray(dataArray, targetId) {
      if (!Array.isArray(dataArray)) {
        return null;
      }
      for (let obj of dataArray) {

        // ค้นหา _id ใน accounts
        if (obj.accounts && obj.accounts._id === targetId) {
          return obj;
        }
        // ค้นหา _id ใน children.accounts
        if (obj.children && obj.children.accounts && obj.children.accounts._id === targetId) {
          return obj.children;
        }

        // // ค้นหา _id ใน children.accounts
        if (obj.children && obj.children.children && obj.children.children.accounts && obj.children.children.accounts._id === targetId) {
          return obj.children.children;
        }
      }
      // ถ้าไม่เจอให้ return null
      return null;
    },

    itemIdentity(item, index) {
      if (!item) {
        return index;
      }
      const title = Array.isArray(item.title) && item.title.length ? item.title[0].value : null;
      return item._id || item.id || item.code || item.key || title || index;
    },

    parentRecordKey() {
      return this.objs && (this.objs._id || this.objs.id || (this.objs.accounts && this.objs.accounts._id))
        ? (this.objs._id || this.objs.id || this.objs.accounts._id)
        : "estimate";
    },

    competencyKey(item, index, type) {
      return `${this.parentRecordKey()}-${type}-competency-${this.itemIdentity(item, index)}-${index}`;
    },







  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
      accounts : "personal/profile"
    }),

    profileStructureItems() {
      const profile = this.$store.getters['personal/profile'] || {};
      const found = this.findObjectByIdInArray(this.objs && this.objs.structure, profile._id);
      return found && Array.isArray(found.item) ? found.item : [];
    }
  },

  watch: {
    objs(value){

    },
    accounts(value){
    }
  }
}
</script>
<style>
</style>
